"use client";
import React, { useState, useEffect } from "react";

export default function FigcaptionToggle({ caption }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = caption.length > 64;
  const displayText = !isLong || expanded ? caption : caption.slice(0, 64) + "...";
  const [maxHeight, setMaxHeight] = useState("none");

  const expandedMax = "min(2000px, 90vh)";

  useEffect(() => {
    if (!isLong) return;
    const id = requestAnimationFrame(() => {
      setMaxHeight(expanded ? expandedMax : "1.5em");
    });
    return () => cancelAnimationFrame(id);
  }, [expanded, isLong]);

  return (
    <span className="toggleFigcaption" style={{ position: "relative", cursor: isLong ? "pointer" : "default", display: "inline-block", width: "100%" }}>
      <div
        style={{
          overflow: "hidden",
          transition: "max-height 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.25s",
          maxHeight: isLong ? maxHeight : "none",
          opacity: expanded || !isLong ? 1 : 0.95,
          display: "inline",
          verticalAlign: "middle",
          whiteSpace: "pre-line"
        }}
      >
        {displayText}
      </div>
      {isLong && (
        <span
          onClick={() => setExpanded((e) => !e)}
          style={{ marginLeft: 8, userSelect: "none", color: "#6C757D", fontWeight: 600, fontSize: "0.8em", verticalAlign: "middle", transition: "color 0.2s" }}
          aria-label={expanded ? "Mostrar menos" : "Mostrar mais"}
          role="button"
          tabIndex={0}
          onKeyPress={e => { if (e.key === "Enter" || e.key === " ") setExpanded(v => !v); }}
        >
          {expanded ? "▲" : "▼"}
        </span>
      )}
    </span>
  );
}
